<template>
  <div class="order" :style="{ fontFamily: fonts,background: 'url(' + bgUrl + ') no-repeat center / 100% 100%' }">
    <home-header @changeFont="changeF"></home-header>
    <div class="adverTemplate">
      <img class="bgIndex1" :src="modelbackground" alt="" />
      <div class="adverBg" v-if="imgShow">
        <img class="bgIndex2" :src="image" alt="" />
        <div class="adverText">
          <div class="upperAdverText">{{ this.theme }}</div>
          <div class="nextAdverText">{{ this.content }}</div>
        </div>
      </div>
      <div class="adverBg" v-if="videoShow">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
          style="width=100%;height=100%"
        ></video-player>
      </div>
      <!-- <div class="adverBg" v-if="imgShow">
                <img :src="image" alt="">
            </div> -->
    </div>
    <div class="prompt">
      <div class="horn"></div>
      <div class="promptText">
        <div class="text">
          {{ meetingName }}正在使用！剩余时间：{{ this.hms }}
        </div>
      </div>
      <div class="buttons">
        <div class="leftButton">
          <div class="orderButton" @click="orderHandle" v-if="apkStatus">
            <div class="orderText">预约</div>
          </div>
        </div>
        <div class="rightButton">
          <div class="signButton" @click="signHandle">
            <div class="signText">签到</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "./header";
import {
  models,
  releases,
  allLists,
  getAdModel,
  getMeetModel,
  saveAttendeeHistorys,
  saveOrderHistory
} from "@/utils/request";
export default {
  components: {
    HomeHeader
  },
  data() {
    return {
      styles: [
        {
          index: 1,
          background: require("../assets/banner.png")
        },
        {
          index: 2,
          background: require("../assets/banner2.png")
        },
        {
          index: 3,
          background: require("../assets/banner3.png")
        }
      ],
      modelbackground: "",
      bacImage: "",
      image: "",
      meetingName: "",
      equipmentName: "",
      meetingId: "",
      name: "",
      content: "",
      theme: "",
      hms: "",
      startTime: "",
      endTime: "",
      meetStatus: "",
      id: "",
      sourceType: "",
      Clock: null,
      modelClock: null,
      fonts: "",
      typeOne: "",
      textShow: false,
      videoShow: false,
      imgShow: false,
      modelBg: "",
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        controls: true, //控制条
        preload: "auto", //视频预加载
        muted: true, //默认情况下将会消除任何音频。
        loop: true, //导致视频一结束就重新开始。
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            src: "" //你所放置的视频的地址，最好是放在服务器上
          }
        ],
        // poster: "http://39.106.117.192:8080/static/indexImg.png", //你的封面地址（覆盖在视频上面的图片）
        width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试" //允许覆盖Video.js无法播放媒体源时显示的默认信息。
      },
      bgUrl:'',
      apkStatus: ''
    };
  },
  mounted() {
    // console.log(this.$route.query)
    this.bgUrl = localStorage.getItem('bgUrl')
    this.apkStatus = localStorage.getItem('apkStatus') === '1' ? true:false
    this.equipmentName = this.$route.query.equipmentName;
    this.meetingId = this.$route.query.meetingId;
    this.meetingName = this.$route.query.meetingName;
    this.theme = this.$route.query.theme;
    this.endTime = this.$route.query.endTime;
    this.startTime = this.$route.query.startTime;
    this.initTemplate();
    this.allLists();
    this.releases();
    const _this = this;
    this.getAdModels();
    if (this.modelClock) {
      clearInterval(this.modelClock);
    } else {
      this.modelClock = setInterval(function() {
        _this.getAdModels();
        //  _this.getMeetModels()
      }, 30000);
    }
  },
  beforeDestroy() {
    if (this.Clock) {
      clearInterval(this.Clock); // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.modelClock) {
      clearInterval(this.modelClock);
    }
  },
  methods: {
    getMeetModels() {
      getMeetModel().then(res => {
        if (Number(res.code) === 0) {
          this.fontStyle = res.data.fontStyle;
        }
      });
    },
    initTemplate() {
      models().then(res => {
        this.styles.forEach((item, index) => {
          if (item.index == Number(res.data[0].color)) {
            this.bacImage = item.background;
          }
        });
      });
    },
    getAdModels() {
      getAdModel().then(res => {
        this.modelBg = Number(res.data.color);
        this.modelbackground = this.styles[this.modelBg - 1].background;
        console.log(this.modelbackground);
      });
    },
    orderHandle() {
      clearInterval(this.Clock);
      this.$router.push({
        path: "/appoint",
        query: {
          equipmentName: this.equipmentName,
          meetingId: this.meetingId,
          meetingName: this.meetingName
        }
      });
    },
    signHandle() {
      localStorage.setItem("isAuto", "no");
      clearInterval(this.Clock);
      this.$router.push({
        path: "/register",
        query: {
          equipmentName: this.equipmentName,
          meetingId: this.meetingId,
          id: this.id,
          meetingName: this.meetingName,
          theme: this.theme,
          startTime: this.startTime,
          endTime: this.endTime
        }
      });
    },
    // 广告信息
    releases() {
      let params = {
        meetingId: this.meetingId
      };
      releases(params).then(res => {
        // console.log(res)
        if (res.code == 0 && res.data.length > 0) {
          this.content = res.data[0].content;
          this.theme = res.data[0].theme;
          this.sourceType = res.data[0].sourceType;
          this.typeOne = res.data[0].typeOne;
          this.image = res.data[0].url;
          this.playerOptions["sources"][0]["src"] = res.data[0].url;
          if (this.sourceType == 1) {
            this.textShow = true;
          }
          if (this.sourceType == 2 && this.typeOne == 1) {
            this.textShow = true;
          }
          if (this.sourceType == 2 && this.typeOne == 2) {
            this.textShow = false;
            this.imgShow = true;
          }
          if (this.sourceType == 3 && this.typeOne == 1) {
            this.textShow = false;
            this.imgShow = false;
            this.videoShow = true;
          }
          if (this.sourceType == 3 && this.typeOne == 2) {
            this.textShow = false;
            this.videoShow = false;
            this.imgShow = true;
          }
        }
      });
    },
    // 会议室信息列表
    allLists(isEnd) {
      let params = {
        meetingId: this.meetingId
      };
      allLists(params).then(res => {
        if (res.code == 0) {
          if (res.data.pageInfoList.list.length > 0) {
            this.startTime = res.data.pageInfoList.list[0].startTime;
            this.endTime = res.data.pageInfoList.list[0].endTime;
            this.meetStatus = res.data.status[0].meetStatus;
            this.id = res.data.pageInfoList.list[0].id;
            this.initDaojishi();
            // if(!this.endTime){
            //     clearInterval(this.Clock)
            //     this.saveAttendeeHistorys()
            //     this.$router.push({path: '/homePage', query: {equipmentName: this.equipmentName, meetingId: this.meetingId, meetingName:this.meetingName}})
            // }
            if (isEnd && !res.data.pageInfoList.list[0].reconfirm) {
              clearInterval(this.Clock);
              this.saveAttendeeHistorys();
              this.$router.push({
                path: "/homePage",
                query: {
                  equipmentName: this.equipmentName,
                  meetingId: this.meetingId,
                  meetingName: this.meetingName
                }
              });
            }
          } else {
            clearInterval(this.Clock);
            this.saveAttendeeHistorys();
            this.$router.push({
              path: "/homePage",
              query: {
                equipmentName: this.equipmentName,
                meetingId: this.meetingId,
                meetingName: this.meetingName
              }
            });
          }
        }
      });
    },
    // 倒计时
    initDaojishi() {
      const _this = this;
      if (this.Clock) {
        clearInterval(this.Clock);
      } else {
        this.Clock = window.setInterval(() => {
          const curdate = new Date().getTime();
          const meetingEndTimeseconds = new Date(_this.endTime).getTime();
          if (meetingEndTimeseconds < curdate) {
            //会议结束了
            this.allLists(true);
            // this.$router.push({path: '/homePage',query: {equipmentName: this.equipmentName, meetingId: this.meetingId, meetingName:this.meetingName}})
          } else {
            let msec = Math.abs(meetingEndTimeseconds - curdate);
            let hr =
              parseInt(msec / 1000 / 60 / 60) >= 10
                ? parseInt(msec / 1000 / 60 / 60)
                : "0" + parseInt(msec / 1000 / 60 / 60);
            let min =
              parseInt((msec / 1000 / 60) % 60) >= 10
                ? parseInt((msec / 1000 / 60) % 60)
                : "0" + parseInt((msec / 1000 / 60) % 60);
            let sec =
              parseInt((msec / 1000) % 60) >= 10
                ? parseInt((msec / 1000) % 60)
                : "0" + parseInt((msec / 1000) % 60);
            _this.hms = hr + ":" + min + ":" + sec;
          }
        }, 1000);
      }
    },
    //保存历史数据
    saveAttendeeHistorys() {
      const data = {
        orderId: this.id
      };
      saveAttendeeHistorys(data).then(res => {
        if (Number(res.code) == 0) {
          saveOrderHistory().then(res => {});
        }
      });
    },
    changeF(font) {
      this.fonts = font;
    }
  }
};
</script>

<style lang="less" scoped>
@background: url(../assets/banner.png) no-repeat;
.order {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .adverTemplate {
    width: 100%;
    height: 70%;
    img {
      width: 100%;
    }
    .adverBg {
      width: 100%;
      height: 100%;
      position: relative;
      img {
        position: absolute;
        width: 100%;
        height: 100%;
      }
      img.bgIndex1 {
        z-index: 5;
      }
      img.bgIndex2 {
        z-index: 10;
      }
      // background: @background;
      .adverText {
        width: 96%;
        height: 76%;
        position: absolute;
        top: 24%;
        left: 4%;
        .upperAdverText {
          width: 50%;
          height: 38%;
          text-align: center;
          font-size: 72px;
          font-family: SimHei;
          font-weight: bold;
          color: #bd53d5;
        }
        .nextAdverText {
          width: 47%;
          text-align: center;
          font-size: 48px;
          font-family: SimHei;
          font-weight: bold;
          color: #121212;
          letter-spacing: 7px;
          line-height: 88px;
        }
      }
    }
  }
  .prompt {
    width: 100%;
    height: 20%;
    display: flex;
    .horn {
      width: 6%;
      height: 100%;
      background: url(../assets/horn.png) no-repeat;
      background-position: 36%;
      // position: relative;
      // top: 36%;
      // left: 3%;
    }
    .promptText {
      width: 65%;
      height: 100%;
      .text {
        font-size: 50px;
        font-family: SimHei;
        font-weight: bold;
        color: #ffb668;
        letter-spacing: 6px;
        height: 100%;
        display: flex;
        align-items: center;
        // line-height: 216px;
        // padding: 5%;
      }
    }
    .buttons {
      display: flex;
      width: 25%;
      font-family: SimHei;
      .leftButton {
        // width: 12%;
        height: 100%;
        flex: 1;
        .orderButton {
          width: 100%;
          height: 100%;
          background: url(../assets/qiandao.png) no-repeat;
          background-position: center center;
          // background-size: 95% 100%;
          // margin-top: 25px;
          .orderText {
            width: 100%;
            font-size: 49px;
            font-weight: bold;
            color: #7de8c4;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(0deg, #1bf7e9 0%, #2ad7ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
      .rightButton {
        // width: 9%;
        flex: 1;
        height: 100%;
        .signButton {
          width: 100%;
          height: 100%;
          background: url(../assets/qiandao.png) no-repeat;
          background-position: center center;
          // margin-top: 25px;
          .signText {
            width: 100%;
            font-size: 49px;
            font-weight: bold;
            color: #7de8c4;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(0deg, #1bf7e9 0%, #2ad7ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1500px) {
  .order .prompt .buttons {
    width: 40%;
  }
}
@media screen and (max-width: 1400px) {
  .order .prompt .buttons .leftButton .orderButton {
    background-size: 60%;
  }
  .order .prompt .buttons .rightButton .signButton {
    background-size: 60%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Advertising.vue